import React from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Button, Alert, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { getUnenrolledStudentInfo } from '../../redux/actions/unenrolledStudent'
import { handleExpiredAuthState } from '../../redux/actions/authActions'
import { connect } from 'react-redux'
import OwnEnrollmentDocumentsApi from '../../api/OwnEnrollmentDocumentsApi'
import { ApiException, ExpiredSessionException, ValidationException } from '../../api/exceptions'

const api = new OwnEnrollmentDocumentsApi();

const FileButton = ({ setFile, slug, nssRef, getUnenrolledStudentInfo, handleExpiredAuthState }) => {
  const MySwal = withReactContent(Swal)

  const handleFile = async () => {

    const AlertValidate =  <Alert variant="info">Tamaño m&aacute;ximo de 300Kb, y solo formato PDF.</Alert>

    await MySwal.fire({
      title: 'Selecciona un documento',
      input: 'file',
      confirmButtonText:'Aceptar',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Sube tu documento'
      },
      html: AlertValidate,
      showLoaderOnConfirm: true,
      inputValidator: (file) => {
        return new Promise((resolve) => {
          !file ?
            resolve('Seleccione un archivo')
            : file.size > 300000
              ? resolve('El archivo excede del tamaño solicitado.')
              : resolve()
        })
      },
      preConfirm: async (file) => {
        const formData = new FormData()
        formData.append('documento', file, file.name)
        /** This part make reference to NSS input */
        nssRef.current !== undefined && formData.append('numero_de_seguro_social',nssRef.current.value)
        api.store(slug, formData)
          .then( response => {
            MySwal.fire({
              icon: 'success',
              title: 'Documento subido con éxito.'
            })
            setFile({
              aceptado: null
            })
            getUnenrolledStudentInfo()
          }).catch( error => {
            if (error instanceof ExpiredSessionException) {
              return handleExpiredAuthState();
            }

            let message = 'Hubo un error al procesar la solicitud. Intente más tarde.';

            if (error instanceof ValidationException && error.errors.numero_de_seguro_social) {
              message = error.errors.numero_de_seguro_social[0]
            } else if (error instanceof ApiException) {
              message = error.message;
            }
            
            MySwal.fire({
              icon: 'error',
              title: message
            })
          })
        }
      })
  }

  return (
    <OverlayTrigger
      overlay={
        <Tooltip>
         <strong>Subir documento</strong>
        </Tooltip>
      }
    >
      <Button variant="info" onClick={handleFile} >
        <i className=" fa fa-upload"></i>
      </Button>
    </OverlayTrigger>
  )
}

export default connect(null,{ getUnenrolledStudentInfo,handleExpiredAuthState })(FileButton)